<template>
  <qd-dropdown
    v-if="displayDropDown"
    :position="position"
    :aria-role="ariaRole"
    :dropdownItems="dropdownItemsModified"
    :disabled="disabled">
    <template #trigger>
      <qd-button v-if="isButton" class="mgb-0">
        <qd-icon type="is-default" icon="dots-vertical"/>
      </qd-button>
      <a v-else>
        <qd-icon
          type="is-default"
          icon="dots-vertical"
          custom-class="has-text-icon-more is-cursor-pointer"/>
      </a>
    </template>
  </qd-dropdown>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    dropdownItems: {
      type: Array,
      required: true,
    },
    permission: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: String,
      required: false,
      default: 'is-bottom-left',
    },
    'aria-role': {
      type: String,
      required: false,
      default: 'list',
    },
    isButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...Permissions.mapActions({
      showPopup: 'showPopup',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    displayDropDown() {
      return !!this.dropdownItems && this.dropdownItems.length > 0;
    },
    dropdownItemsModified() {
      if (this.dropdownItems.length === 0) return [];
      const actions = this.dropdownItems.map((item) => {
        let itemAction = () => { this.showPopup(); };
        const permission = item.permission ? item.permission : this.permission;
        if (!permission || this.checkPermissions(permission)) {
          itemAction = () => { item.action(); };
        }
        return {
          libelle: item.libelle,
          action: itemAction,
          id: item.id,
          disabled: item.disabled,
        };
      });
      actions.sort((a, b) => a.id - b.id);
      return actions;
    },
  },
};
</script>
